import { SUPPORT_TRANSPORT_CHANNEL_URL } from 'app/network/chat/channel';
import { CustomChannelType, type Channel } from 'app/types/chat';

const TRANSPORT_SUPPORT_CHANNEL_NAME = 'Aide au transport';

export function isTransportSupportChannel(channel: Pick<Channel, 'channel_url' | 'custom_type' | 'name'>): boolean {
  // The API resolves the virtual URL to a persisted channel ID, so use the
  // support channel's stable name as the fallback once it has been resolved.
  return (
    channel.channel_url === SUPPORT_TRANSPORT_CHANNEL_URL ||
    (channel.custom_type === CustomChannelType.Support && channel.name === TRANSPORT_SUPPORT_CHANNEL_NAME)
  );
}
